<template>
  <div
    class="
      toast-notify
      left-4
      p-1
      bg-easy-grey
      rounded-xl
      gap-1
      border-2 border-easy-grey
      hover:border-yellow
      z-20
    "
    :style="[{ top: `${6 + index * 3}rem` }]"
  >
    <span class="text-sm flex items-center pr-4" @click="handleNotifClick">
      <UserAddIcon class="h-7 w-7 mx-2 text-vice-teal-700" />
      Would you like to admit
      <span class="font-bold text-vice-teal-900">&nbsp;{{ latecomer.name }}&nbsp;</span>
      to the session?
    </span>
    <button
      @click="handleRequest(latecomer, true)"
      class="
        p-1
        text-xs
        font-semibold
        text-vice-teal-700
        border-light-green
        rounded-md
        border-2
        hover:border-vice-teal-600
        hover:bg-vice-teal-100
      "
    >
      ACCEPT
    </button>
    <button
      @click="handleRequest(latecomer, false)"
      class="
        p-1
        text-xs text-red-600
        font-semibold
        border-light-grey
        rounded-md
        border-2
        hover:border-vice-rose-500
        hover:bg-vice-rose-100
      "
    >
      DENY
    </button>
    <button @click="closeToast">
      <CrossSimpleIcon type="link" class="text-vice-dark-grey hover:text-strong-grey" />
    </button>
  </div>
</template>

<script>
import { UserAddIcon } from '@heroicons/vue/solid';
import { onMounted, onUnmounted } from 'vue';
import CrossSimpleIcon from '@/Components/Icons/CrossSimpleIcon.vue';
import useSessionStore from '@/Stores/useSessionStore';

export default {
  components: { UserAddIcon, CrossSimpleIcon },
  emits: ['lateEntryResponse', 'audioNotification'],
  props: {
    index: {
      type: Number,
    },
    latecomer: {
      type: Object,
    },
    showToast: {
      type: Boolean,
      default: true,
    },
    toggleSidebar: {
      type: Function,
    },
    clearToastStack: {
      type: Function,
    },
  },
  setup(props, { emit }) {
    const sessionStore = useSessionStore();

    const handleRequest = (user, accepted) => {
      emit('lateEntryResponse', user, accepted);
    };

    const handleNotifClick = () => {
      props.toggleSidebar(true, 'participantsTab');
    };

    const closeToast = () => {
      props.clearToastStack(props.latecomer.id);
    };

    onMounted(() => {
      sessionStore.toastCount += 1;
      emit('audioNotification');
    });

    onUnmounted(() => {
      sessionStore.toastCount -= 1;
    });

    return { handleRequest, closeToast, handleNotifClick };
  },
};
</script>

<style scoped></style>
